import React, { useState } from 'react';
import { Formik, Form, FormikHelpers } from 'formik';
import { IActionvationWhoForm } from 'core/interface/activation';
import FormField from 'components/FormField/Index';
import { InputType } from 'core/enum/inputType';
import Button from 'components/Button/Index';
import Activation from 'components/feature/activation/Index';
import ImagePicker from 'components/imagePicker';
import useLocales from 'hooks/useLocales';
import { validationSchema } from './form';
import { isValidURL } from 'helpers/isValidURL';
import ReactQuill from 'react-quill';

import 'react-quill/dist/quill.snow.css';
import './Index.scss';

const CreateCareer: any = ({
  onSubmit,
  onClose,
  setCompanyData,
  companyData,
  isPopup = false,
  className,
  isOneBtn = false,
  showTopSide,
  setNewData,
  showTitle
}: any): JSX.Element => {
  const { t } = useLocales();
  const [companyLogo, setCompanyLogo] = useState<any>(
    companyData?.logo ? companyData?.logo : null
  );
  const [mainLogo, setMainLogo] = useState<any>(
    companyData?.hero_img ? companyData?.hero_img : null
  );
  const [formValues, _] = useState<any>({
    title: companyData?.title || '',
    about_us: companyData?.about_us || ''
  });

  const handleSubmit = (
    values: IActionvationWhoForm,
    actions: FormikHelpers<IActionvationWhoForm>
  ) => {
    if (setCompanyData) {
      setCompanyData((prev: any) => ({
        ...prev,
        logo: companyLogo,
        hero_img: mainLogo,
        ...values
      }));
    } else {
      const data = {
        ...values,
        ...(!isValidURL(companyLogo) ? { logo: companyLogo } : {}),
        ...(!isValidURL(mainLogo) ? { hero_img: mainLogo } : {})
      };
      setNewData(data);
    }
    onSubmit && onSubmit();
  };

  const modules = {
    toolbar: [
      [{ font: [] }],
      [{ size: ['small', false, 'large', 'huge'] }],
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ color: [] }, { background: [] }],
      ['clean']
    ],
    clipboard: {
      // Toggle to add extra line breaks when pasting HTML:
      matchVisual: false
    }
  };

  const formats = [
    'header',
    'font',
    'size',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'link',
    'color',
    'background'
  ];

  return (
    <div
      className="who"
      onClick={isPopup ? (e) => e.stopPropagation() : () => {}}
    >
      <Activation
        showTopSide={showTopSide}
        title={t('Create career page')}
        currentStep={1}
        className={
          isPopup ? '' : `activation-edu ${className ?? ''} ${className}`
        }
        headerIconDisable
        totalSteps={8}
        isCareerPage={true}
        handleModalClose={onClose}
        isPopup={true}
        showTitle={showTitle}
        style={{
          maxHeight: '90vh',
          overflowY: 'hidden',
          width: 'auto'
        }}
      >
        <Formik
          enableReinitialize
          initialValues={formValues}
          onSubmit={(values, actions) => handleSubmit(values, actions)}
          validationSchema={validationSchema(t)}
        >
          {({
            setFieldValue,
            isValid,
            values,
            errors,
            touched,
            setFieldTouched
          }) => {
            return (
              <Form>
                <div className="career-form-container scrollable">
                  {/* <div className="fields">
                    <span className="label">{t('Title')}</span>
                    <FormField
                      inputClassName="input"
                      fieldName="title"
                      placeholder="Text"
                      type={InputType.text}
                    />
                  </div> */}
                  <div className="fields">
                    <span className="label">{t('About us')}</span>
                    <ReactQuill
                      value={values.about_us}
                      onChange={(content) => setFieldValue('about_us', content)}
                      modules={modules}
                      formats={formats}
                      placeholder="Enter about us"
                      className="quill-editor"
                      theme="snow"
                      preserveWhitespace={true}
                    />
                    {touched.about_us && errors.about_us ? (
                      <div className="error">{t('About us is required')}</div>
                    ) : null}
                  </div>
                  <div className="imagePickerContainer">
                    <div>
                      <span className="label">{t('Company logo')}</span>
                      <ImagePicker
                        setLogo={setCompanyLogo}
                        logo={companyLogo}
                        max={1}
                      />
                    </div>
                    <div>
                      <span className="label">{t('Main photo')}</span>
                      <ImagePicker
                        setLogo={setMainLogo}
                        logo={mainLogo}
                        max={1}
                      />
                    </div>
                  </div>
                  {!isOneBtn ? (
                    <Button
                      className={`next ${!isValid ? 'invalid' : `${isValid}`}`}
                      type="submit"
                      title="Next"
                      t={t}
                    />
                  ) : (
                    <Button
                      className={`next button ${
                        !isValid ? 'invalid-btn' : ''
                      } ${isOneBtn ? 'one-btn' : ''}`}
                      type="submit"
                      t={t}
                      title={'Save'}
                    />
                  )}
                </div>
              </Form>
            );
          }}
        </Formik>
      </Activation>
    </div>
  );
};

export default CreateCareer;
